import type { ApplicationPageData } from '../..';

export interface PrefsProps
  extends Pick<ApplicationPageData, 'breedOptions' | 'breederSpokenLanguages'> {}
